import { render, staticRenderFns } from "./MenuClientApps.vue?vue&type=template&id=31cec1b8&scoped=true&"
import script from "./MenuClientApps.vue?vue&type=script&lang=ts&"
export * from "./MenuClientApps.vue?vue&type=script&lang=ts&"
import style0 from "./MenuClientApps.vue?vue&type=style&index=0&id=31cec1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cec1b8",
  null
  
)

export default component.exports